export default __webpack_public_path__ + "static/media/snowuns-book.eecd4023.png";